import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, effect, ViewEncapsulation } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { Router } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { DdcAppstoreBtnSmallComponent } from '../ddc-appstore-btn-small/ddc-appstore-btn-small.component'

@Component({
  selector: 'ddc-upgrade-mobile-sheet',
  templateUrl: './ddc-upgrade-mobile-sheet.component.html',
  styleUrl: './ddc-upgrade-mobile-sheet.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    MatIconModule,
    MatDividerModule,
    DdcAppstoreBtnSmallComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcUpgradeMobileSheetComponent {
  _isDarkTheme = false
  _isLightTheme = true
  _isPaperTheme = false

  constructor(
    private _themeService: ThemeService,
    private _dialogRef: MatDialogRef<DdcUpgradeMobileSheetComponent>,
    private _router: Router,
  ) {
    this._themeService.theme$.subscribe(theme => {
      this._isDarkTheme = theme === 'dark-theme'
      this._isLightTheme = theme === 'light-theme'
      this._isPaperTheme = theme === 'paper-theme'
    })

    // React to word changes
    effect(() => {
      this.setupProfilePicData()
    })
  }

  private setupProfilePicData(): void {}

  protected onUpgradeClick(): void {
    // Handle upgrade click logic here
    this._dialogRef.close()
  }

  protected goToUpgrade(): void {
    this._dialogRef.close()
    this._router.navigate(['/pricing'])
  }
}
